// DO NOT EDIT THIS FILE. It should be automatically generated by running
// pnpm generate-product-types

// This object is used to find the base product of a given product
export const productBaseProductMapping = {
  unified_legal_comfort_3_basic_roland_de: 'unified_legal_comfort_3_basic_roland_de',
  unified_bike_theft_premium_basic_neodigital_de: 'unified_bike_theft_premium_basic_neodigital_de',
  pet_health_v1_getsafe_de: 'pet_health_v1_getsafe_de',
  contents_v1_getsafe_de: 'contents_v1_getsafe_de',
  dog_liability_v1_getsafe_de: 'dog_liability_v1_getsafe_de',
  liability_v1_getsafe_de: 'liability_v1_getsafe_de',
  dental_ottonova_100_plus_de: 'dental_ottonova_100_plus_de',
  dental_ottonova_90_plus_de: 'dental_ottonova_90_plus_de',
  dental_ottonova_75_plus_de: 'dental_ottonova_75_plus_de',
  car_comfort_basic_iptiq_de: 'car_comfort_basic_iptiq_de',
  legal_basis_3_basic_roland_de: 'legal_basis_3_basic_roland_de',
  legal_basis_3_tenant_roland_de: 'legal_basis_3_basic_roland_de',
  legal_basis_3_criminal_roland_de: 'legal_basis_3_basic_roland_de',
  legal_comfort_3_basic_roland_de: 'legal_comfort_3_basic_roland_de',
  legal_comfort_3_tenant_roland_de: 'legal_comfort_3_basic_roland_de',
  legal_comfort_3_criminal_roland_de: 'legal_comfort_3_basic_roland_de',
  bike_theft_comfort_basic_neodigital_de: 'bike_theft_comfort_basic_neodigital_de',
  bike_theft_comfort_comprehensive_neodigital_de: 'bike_theft_comfort_basic_neodigital_de',
  bike_theft_premium_basic_neodigital_de: 'bike_theft_premium_basic_neodigital_de',
  bike_theft_premium_comprehensive_neodigital_de: 'bike_theft_premium_basic_neodigital_de',
  liability_premium_basic_neodigital_de: 'liability_premium_basic_neodigital_de',
  liability_premium_drones_neodigital_de: 'liability_premium_basic_neodigital_de',
  contents_comfort_basic_neodigital_de: 'contents_comfort_basic_neodigital_de',
  contents_comfort_glass_neodigital_de: 'contents_comfort_basic_neodigital_de',
  contents_comfort_natural_disasters_neodigital_de: 'contents_comfort_basic_neodigital_de',
  contents_comfort_bike_theft_neodigital_de: 'contents_comfort_basic_neodigital_de',
  contents_premium_basic_neodigital_de: 'contents_premium_basic_neodigital_de',
  contents_premium_glass_neodigital_de: 'contents_premium_basic_neodigital_de',
  contents_premium_natural_disasters_neodigital_de: 'contents_premium_basic_neodigital_de',
  contents_premium_bike_theft_neodigital_de: 'contents_premium_basic_neodigital_de',
  liability_basic_neodigital_de: 'liability_basic_neodigital_de',
  liability_drones_neodigital_de: 'liability_basic_neodigital_de',
  dog_liability_basic_de: 'dog_liability_basic_de',
  dog_liability_premium_de: 'dog_liability_basic_de',
  liability_v1_getsafe_at: 'liability_v1_getsafe_at',
  dog_liability_v1_getsafe_at: 'dog_liability_v1_getsafe_at',
  household_v1_getsafe_at: 'household_v1_getsafe_at',
  home_v1_getsafe_fr: 'home_v1_getsafe_fr',
}
